/** The parts of a supplier file the grouping reads. */
interface CategorisedDownload {
    Title?: string | null;
    FileCategory?: { Title?: string | null } | null;
}

/** One row of the downloads band: a category and the files filed under it. */
export interface DownloadCategoryRow<T> {
    name: string;
    downloads: T[];
}

/**
 * Groups a product's files into one row per category.
 *
 * Every known category gets a row, empty or not, in the order given, so an
 * empty one can still be asked for. A file under a category the list does not
 * know still belongs on the page: those go in after, grouped by their own
 * category the same way, so two files under it share one row rather than
 * printing the same name twice. A file with no category is named by its title.
 */
export const groupDownloadsByCategory = <T extends CategorisedDownload>(
    downloads: T[],
    categories: readonly string[],
): DownloadCategoryRow<T>[] => {
    const byName = new Map<string, T[]>(categories.map((name) => [name, []]));
    downloads.forEach((download) => {
        const name = download.FileCategory?.Title ?? download.Title ?? 'File';
        byName.set(name, [...(byName.get(name) ?? []), download]);
    });
    return [...byName].map(([name, files]) => ({ name, downloads: files }));
};
